function normalizeDownloadTarget(target, apiBase = '/api/v1') {
  if (typeof target !== 'string') return target;
  return target.startsWith(`${apiBase}/`) ? target.slice(apiBase.length) : target;
}
module.exports = { normalizeDownloadTarget };
